export default "__VITE_ASSET__JPsDU8bb__"